export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./aggregator-games-list.vue?vue&type=template&id=07647b50&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/common/aggregator-games-list.vue?vue&type=template&id=07647b50&scoped=true
// module id = U7Fr
// module chunks = 0